module.exports = __webpack_public_path__ + "static/media/30.3245b573.png";